"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'DiiCa',
    organizationId: 'mP6k1FdSNmmEVNbMJVaZ',
    applicationKey: 'diica',
    applicationType: 'organization',
    artistId: undefined,
    theme: { dark: true },
    version: '1.3',
    ionicAppId: '10b68c78',
    platform: ['native'],
    ios: {
        bundleId: 'jp.diica',
        appId: '1597719315',
    },
    android: {
        bundleId: 'jp.diica',
    },
    deeplinkUrl: 'https://app.diica.jp',
    helpUrl: 'https://help.utoniq.com/ja/collections/3305438',
    applink: 'app.diica.jp',
    deeplinkStg: 'diica-stg.netlify.app',
    deeplinkProd: 'app.diica.jp',
    custom: {
        modules: {
            tutorial: true,
            trade: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            liveStream: true,
            item: true,
            campaign: true,
            mission: true,
            eprint: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'notifications', 'myProfile'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'threads'],
    },
});
